const angular = require('angular');
var pdfjsImport = require('../imports/pdfjs');

const app = angular.module('learn-directives');

/**
 * Defines the media viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the global Analyze functions and properties
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('presentationFileViewer', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      link: '=',
      fullScreen: '@',
      goNext: '=',
      goPrevious: '=',
      goPage: '=',
      onNext: '&',
      onPrevious: '&',
      onLast: '&',
      totalPages: '=',
      currentPage: '='
    },
    template: require('../../templates/directives/presentation-file-viewer.html'),
    controller: ['$scope', '$q', '$window', '$timeout', function ($scope, $q, $window, $timeout) {
      var self = this;
      var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
      self.uniqueId = '';
      for (var i = 0; i < 13; i++) {
        self.uniqueId += characters[Math.floor(Math.random() * characters.length)];
      }

      var pdfDoc = null;
      var scale = 1;
      var canvas;
      var ctx;
      var currentPage = 1;
      $scope.showLoading = true;
      
      self.navigation = {

        pageNum: 1,
        pageRendering: false,
        pageNumPending: null,
        // Get page info from document, resize canvas accordingly, and render page.
        renderPage: function(num) {
          var deferred = $q.defer();
          currentPage = num;
          this.pageRendering = true;
          // Using promise to fetch the page
          pdfDoc.getPage(num).then(function(page) {
            var viewport;
            var pageViewport = page.getViewport({scale: 1});
            var canvasWidth = $window.innerWidth > document.documentElement.clientWidth ? $window.innerWidth : document.documentElement.clientWidth;
            var canvasHeight = $window.innerHeight > document.documentElement.clientHeight ? $window.innerHeight : document.documentElement.clientHeight;

            if (pageViewport.width > pageViewport.height) {

              viewport = page.getViewport({scale: canvasWidth / pageViewport.width});
              canvas.width = canvasWidth;
              canvas.height = viewport.height;
            } 
            else {

              viewport = page.getViewport({scale: canvasHeight / pageViewport.height});
              canvas.width = viewport.width;
              canvas.height = canvasHeight;
            }

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: ctx,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            $timeout(function(){$scope.showLoading = self.navigation.pageRendering ? true : false;}, 500);

            // Wait for rendering to finish
            renderTask.promise.then(function () {
              self.navigation.pageRendering = false;
              $timeout(function(){$scope.showLoading = false;}, 0);
              if (self.navigation.pageNumPending !== null) {
                // New page rendering is pending
                self.navigation.renderPage(self.navigation.pageNumPending);
                self.navigation.pageNumPending = null;
              }
              deferred.resolve();
            });
          });

          return deferred.promise;
        },
        queueRenderPage: function (num) {
          if (this.pageRendering) {
            var deferred = $q.defer();
            this.pageNumPending = num;
            deferred.reject();
            return deferred.promise;
          } else {
            return this.renderPage(num);
          }
        },
        loadPage : function(pageLoad){
          if(pageLoad < 1 || pageLoad > pdfDoc.numPages){
            var deferred = $q.defer();
            deferred.reject();
            return deferred.promise;
          }

          this.pageNum = $scope.goPage;
          return this.queueRenderPage(this.pageNum)
          .then(function() {
            $scope.currentPage = self.navigation.pageNum;
          });
        },
        previous: function() {
          if (this.pageNum <= 1) {
            var deferred = $q.defer();
            deferred.reject();
            return deferred.promise;

          }
          this.pageNum--;
          return this.queueRenderPage(this.pageNum)
          .then(function() {
            $scope.currentPage = self.navigation.pageNum;
            if ($scope.onPrevious) {
              $scope.onPrevious({page: self.navigation.pageNum});
            }
          });
        },
        next: function() {
          if (!pdfDoc || this.pageNum >= pdfDoc.numPages) {
            var deferred = $q.defer();
            deferred.reject();
            return deferred.promise;
          }
          this.pageNum++;
          return this.queueRenderPage(this.pageNum)
          .then(function() {
            $scope.currentPage = self.navigation.pageNum;
            if ($scope.onPrevious) {
              $scope.onNext({page: self.navigation.pageNum});
            }
            if (self.navigation.pageNum === self.navigation.totalPages && $scope.onLast) {
              $scope.onLast();
            }
          });
        }
      };

      var initialize = async function() {
        self.navigation.pageNum = $scope.goPage ? $scope.goPage : 1;
        const PDFJS = await pdfjsImport.importModule();
        PDFJS.disableWorker = true;
        PDFJS.getDocument($scope.link).promise.then(function (pdfDoc_) {
          pdfDoc = pdfDoc_;
          $scope.totalPages = pdfDoc.numPages;
          $scope.$apply(self.navigation.totalPages = pdfDoc.numPages);
          // Initial/first page rendering
          self.navigation.renderPage(self.navigation.pageNum);
        });
      };


      //rerender page on resize
      function onResize(){
        self.navigation.renderPage(currentPage);
      };

      angular.element($window).on('resize', onResize);

      $scope.$on('$destroy', function() {
        angular.element($window).off('resize', onResize);
      });


      $scope.$watch('link', async function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          await initialize();
        }
      });

      setTimeout(async function() {
        canvas = document.getElementById(self.uniqueId);
        ctx = canvas.getContext('2d');
        if ($scope.link) {
          await initialize();
        }
      });

      if ($scope.fullScreen) {
        $scope.$watch('goNext', function(newVal, oldVal) {
          if (newVal && !oldVal) {
            self.navigation.next()
            .then(function() {
              $scope.goNext = false;
              $scope.goPrevious = false;
              $scope.goPage = false;
            })
          }
        });
        $scope.$watch('goPrevious', function(newVal, oldVal) {
          if (newVal && !oldVal) {
            self.navigation.previous()
            .then(function() {
              $scope.goPrevious = false;
              $scope.goNext = false;
              $scope.goPage = false;
            })
          }
        });
        $scope.$watch('goPage', async function(newVal, oldVal) {
          if (newVal && !oldVal) {
            if (!pdfDoc) {
              await initialize();
              return;
            }

            self.navigation.loadPage($scope.goPage)
            .then(function() {
              $scope.goPage = false;
              $scope.goPrevious = false;
              $scope.goNext = false;
            })
          }          
        });
      }

    }],
    controllerAs: 'pdfview'
  }
}]);